import PropTypes from 'prop-types';
import { ModalGeneric } from 'ypf-pas-general-ui-components';

import './AssignProviderModal.scss';

const ErrorAssignModal = (props) => {
  const {
    setShowModalError,
    setProviderData,
    setIsChecked,
    errorEnum,
    showModalError,
    setActiveTab,
    numero,
    proveedor
  } = props;

  const closeModal = () => {
    setShowModalError(false);
    setProviderData(null);
    setIsChecked(null);
  };

  return (
    <ModalGeneric
      backdrop="static"
      infoModal
      onHide={() => closeModal()}
      primaryAction={() => {
        setShowModalError(false);
        setProviderData(null);
        setIsChecked(null);
        if (errorEnum === 1) {
          setActiveTab('aprobadores');
        } else {
          setActiveTab('comunicar');
        }
      }}
      primaryActionLabel="Aceptar"
      secondaryAction={() => closeModal()}
      secondaryActionLabel="Salir"
      show={showModalError}
      size="md"
      title={`Sin ${errorEnum === 1 ? 'aprobadores' : 'supervisores'} cargados`}
      variantHeader="warning"
    >
      <div className="modal_body_error">
        Para poder asignar la solicitud de servicio <strong> {`N° ${numero} `}</strong> al proveedor{' '}
        <strong> {`${proveedor} `}</strong> es necesario que{' '}
        <strong>
          selecciones al menos un{' '}
          {` ${errorEnum === 1 ? ' Aprobador ' : ' Notificador (Supervisor YPF) '}`}
        </strong>
        en la sección {` ${errorEnum === 1 ? ' APROBADORES' : ' COMUNICAR A'}`}.
      </div>
    </ModalGeneric>
  );
};

export default ErrorAssignModal;

ErrorAssignModal.propTypes = {
  setShowModalError: PropTypes.func.isRequired,
  setProviderData: PropTypes.func.isRequired,
  setIsChecked: PropTypes.func.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  errorEnum: PropTypes.number,
  showModalError: PropTypes.bool.isRequired,
  numero: PropTypes.string.isRequired,
  proveedor: PropTypes.string
};

ErrorAssignModal.defaultProps = {
  proveedor: '',
  errorEnum: null
};
